import { remove } from 'ramda';
import { onFormChange } from '../../../actions/form';
import { ReduxComponentInterface } from 'edocatbase/Global';
import { ControlInterface } from 'edocatbase/Form';
import { Dispatch } from 'redux';
import { getNamesByNodesForTableProps } from '../../../actions/form';
import React from 'react';
import { Theme } from '@material-ui/core/styles';

const { Icon, Tooltip, withStyles, Link } = window.Material;

const {
	actions: { toggleModal },
} = window.Edocat.Components.ModalTest;

interface TrProps extends ReduxComponentInterface {
	index: number;
	row: any;
	rowDislplayValues: any;
	wholeTableValues: any;
	headers: { key: string; id: string; type: string; label?: string }[];
	formInstanceId: string;
	isViewOnly: boolean;
	styles: object;
	name: string;
}

const ellipsis = (text: any, chars: number): any => {
	let dislplayValue = typeof text === 'string' ? text : "";
	let shortText = dislplayValue.substring(0, chars);
	let tooltipValue = dislplayValue.split(/\n/).reduce((acc: any[], it: any) => { return [...acc, <React.Fragment key={Math.floor(Math.random() * 10000)}><p>{it}</p><hr /></React.Fragment>] }, [<hr key={Math.floor(Math.random() * 10000)} />]);
	return <span>{(shortText.length < dislplayValue.length ?
		<HtmlTooltip
			enterDelay={1000} leaveDelay={100}
			title={<React.Fragment> {tooltipValue}</React.Fragment>}>
			<span style={{ cursor: 'help' }}>{shortText}...</span>
		</HtmlTooltip> : dislplayValue)}
	</span>;
}

const HtmlTooltip = withStyles((theme: Theme) => ({
	tooltip: {
		padding: '0.8em',
		backgroundColor: '#ffffff',
		color: 'rgba(0, 0, 0, 0.87)',
		maxWidth: 600,
		fontSize: '1em',
		fontWeigth: 'normal',
		border: "1px solid gray",
		'& hr': {
			pointer: 'help',
			borderTop: "1px solid #f0f0f0"
		},
		'& .tooltipLink': {
			pointer: 'help',
		}
	},

}))(Tooltip);

class Tr extends React.PureComponent<TrProps> {
	onEditClick = (event: React.MouseEvent) => {
		event.preventDefault();
		const { actions, name, row, index, formInstanceId } = this.props;
		actions.toggleModal(
			true,
			`form${name}`,
			{
				data: row,
				index,
				isNew: false,
			},
			formInstanceId
		);
	};

	onDeleteClick = (event: React.MouseEvent) => {
		event.preventDefault();
		const { actions, name, wholeTableValues, index, formInstanceId } = this.props;
		actions.onFormChange(formInstanceId, [name], remove(index, 1, wholeTableValues));
	};

	render() {
		const { index, row, headers, isViewOnly, rowDislplayValues } = this.props;

		return (
			<tr>
				{!isViewOnly && (
					<td>
						<div className="tableActionsCell">
							<Icon className="fas fa-trash-alt action-button-formtable" onClick={this.onDeleteClick} />
							<Icon className="fas fa-pen action-button-formtable" onClick={this.onEditClick} />
						</div>
					</td>
				)}
				{headers.map((header: { id?: string; key?: string; label?: string; type: string }, cid: number) => {
					const key: string = header?.id ? header.id : (header?.key ? header.key : "");
					const elementKey = key + "-" + index + "-" + cid
					const dislplayValue = rowDislplayValues[key] ?? null;
					const value = row[key] ?? null;
					return (
						<td key={elementKey} className={!value ? "tableNoValue" : ""}>
							{typeof header?.type === 'string' &&
								header?.type?.toLowerCase() === 'textareafield' ?
								<span>{ellipsis(dislplayValue, 30)}</span>
								: <span>{dislplayValue}</span>}
						</td>
					);
				})}
			</tr>
		);
	}
}

const mapDispatchToProps = (dispatch: Dispatch) => ({
	actions: window.redux.bindActionCreators({ toggleModal, onFormChange }, dispatch),
});

export default window.reactRedux.connect(null, mapDispatchToProps)(Tr);
